import { Injectable, inject } from '@angular/core';

import { FsApi } from '@firestitch/api';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { SessionService } from './session.service';
import { SigninService } from './signin.service';


@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _signinService = inject(SigninService);
  private _sessionService = inject(SessionService);
  private _api = inject(FsApi);


  public verify(password): Observable<any> {
    return this._api.post('auth/verify', { password });
  }

  public reloadPermissions(): Observable<any> {
    return this._api.get('auth/permissions')
      .pipe(
        tap((permissions) => {
          this._sessionService.permissions(permissions);
        }),
      );
  }

}
